module.exports = __webpack_public_path__ + "img/cloud.00e9f7a8.png";